export const DEFAULT_TRIAL_PERIOD_DAYS = 14;

export const USERS_WITH_REDUCED_FUNCTIONALITY = [
    1_983_203, 1_711_540, 1_807_729, 1_962_707, 1_979_630, 1_990_292, 2_054_225,
];
